



























import ListItem from '@/components/list/ListItem.vue'
import {Component, Prop, Vue} from 'vue-property-decorator'

/**
 * @displayName Toast
 * mainLayout 상단 toast message item
 */
@Component({
  components: {ListItem},
})
export default class Toast extends Vue {
  /**
   * display toast message
   */
  @Prop({default: '', type: String}) message: string
  /**
   * unique id
   */
  @Prop({default: '', type: String}) id: string
  /**
   * auto close duration time
   */
  @Prop({default: 3000, type: Number}) duration: number

  created() {
    /**
     * auto close
     */
    setTimeout(() => {
      this.$emit('remove', this.id)
    }, this.duration)
  }
}
